module.exports = __webpack_public_path__ + "img/refresh.7f1ca412.svg";